import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { routes } from './app.router';
import { AppComponent } from './app.component';
// import { ProductsComponent } from './products/products.component';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { MatDialogModule } from '@angular/material/dialog';
import { initializeKeycloak } from './core/utils/utility.init';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { AdaAccessComponent } from './features/ada-access/ada-access.component';
import { dataProtectionRouter } from './features/data-protection/data-protection.router';
import { DataProtectionModule } from './features/data-protection/data-protection.module';
import { ProductsDropdownComponent } from './navbar/products-dropdown/products-dropdown.component';
import { NgChartsModule } from 'ng2-charts';


import { digitalIdentityRouter } from './features/digital-identity/digital-identity.router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdaAccessModule } from './features/ada-access/ada-access.module';
import { adaAccessRouter } from './features/ada-access/ada-access.router';
import { AssetManagementModule } from './features/asset-management/asset-management.module';
import { assetManagementRouter } from './features/asset-management/asset-management.router';
import { DigitalIdentityModule } from './features/digital-identity/digital-identity.module';
import { DigitalIdentityComponent } from './features/digital-identity/digital-identity.component';


import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingInterceptor } from './core/interceptor/loading.interceptor';
import { KeycloakStateService } from './core/service/utility.service';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { UserManagementComponent } from './features/user-management/user-management.component';
import { UserManagementModule } from './features/user-management/user-management.module';
import { AdaAccessAuthoringToolsComponent } from './features/ada-access/auth-tool-home/authoring-tools/ada-access-authoring-tools.component';
import { AssetManagementAuthoringToolsComponent } from './features/asset-management/auth-tools/asset-management-authoring-tools/asset-management-authoring-tools.component';
import { DataProtectionAuthoringToolsComponent } from './features/data-protection/auth-tools/data-protection-authoring-tools/data-protection-authoring-tools.component';
import { DigitalIdentityAuthoringToolsComponent } from './features/digital-identity/authoring-tools/digital-identity-authoring-tools.component';
import { HomeComponent } from './home/home.component';
import { GuideComponent } from './guide/guide.component';
import { DsoGuardComponent } from './features/dso-guard/dso-guard.component';
import { dsoGuardRouter } from './features/dso-guard/dso-guard.router';
import { DsoGuardModule } from './features/dso-guard/dso-guard.module';
import { SecureBlockchainModule } from './features/secure-blockchain/secure-blockchain.module';
import { secureBlockchainRouter } from './features/secure-blockchain/secure-blockchain.router';
import { InsightEgrcModule } from './features/insight-egrc/insight-egrc.module';
import { insightEgrcRouter } from './features/insight-egrc/insight-egrc.router';
import { SecureBlockchainComponent } from './features/secure-blockchain/secure-blockchain.component';
import { InsightEgrcComponent } from './features/insight-egrc/insight-egrc.component';
import { SecureZoneModule } from './features/security-zone/secure-zone.module';
import { DataAssetCaptureModule } from './features/shared-workflows/data-asset-capture/data-asset-capture.module';
import { DataAssetConfigurationModule } from './features/shared-workflows/data-asset-configuraion/data-asset-configuration.module';
import { SystemAssetCaptureModule } from './features/shared-workflows/system-asset-capture/system-asset-capture.module';
import { ZoneManagementModule } from './features/shared-workflows/zone-management/zone-management.module';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    AdaAccessComponent,
    ProductsDropdownComponent, 
    DigitalIdentityComponent,
    UserManagementComponent,
    AdaAccessAuthoringToolsComponent,
    AssetManagementAuthoringToolsComponent,
    DataProtectionAuthoringToolsComponent,
    DigitalIdentityAuthoringToolsComponent,
    HomeComponent,
    GuideComponent,
    DsoGuardComponent,
    SecureBlockchainComponent,
    InsightEgrcComponent

  ],

  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    routes,
    SharedModule,
    RouterModule,
    BrowserAnimationsModule,
    MatDialogModule,
    KeycloakAngularModule,
    AdaAccessModule,
    DataProtectionModule,
    AssetManagementModule,
    DigitalIdentityModule,
    DsoGuardModule,
    SecureBlockchainModule,
    InsightEgrcModule,
    SecureZoneModule,
    MatButtonModule,
    MatTooltipModule,
    NgbModule,
    LoadingBarModule,
    LoadingBarRouterModule,
    LoadingBarHttpClientModule,
    NgChartsModule,
    AgGridModule,
    AgGridAngular,
    UserManagementModule,
    DataAssetCaptureModule,
    DataAssetConfigurationModule,
    SystemAssetCaptureModule,
    ZoneManagementModule

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      deps: [KeycloakService,KeycloakStateService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true
    },
    //IdleActivityService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
